import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import API from "@/api";
import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  codeUsingGet,
  editMyUserPhoneUsingPost,
  editMyUserUsingPost,
  getCodeUsingGet,
} from "@/request/api/userController";
import PictureUpload from "@/components/picture/PictureUpload.vue";
import { useLoginUserStore } from "@/store/userStore";
//查询登录用户

export default /*#__PURE__*/_defineComponent({
  __name: 'UserEditPage',
  setup(__props) {

const loginUserStore = useLoginUserStore();
const loginUser = ref<API.UserVO>(loginUserStore.loginUser);

/**
 * 修改
 */
//要修改的数据
const updateUser = ref<API.UserUpdateMyRequest>({ ...loginUser.value });
const updateVisible = ref(false);

const reset = () => {
  updateUser.value = {};
  updateUser.value = {
    ...loginUser.value,
  };
};
/**
 * 提交用户信息
 */
const submitUser = async () => {
  updateLoading.value = true;
  if (updateUser.value.userName == "") {
    message.error("请输入用户名");
    return;
  }
  if (updateUser.value.userAvatar == "") {
    message.error("请输入头像");
    return;
  }
  const response = await editMyUserUsingPost(updateUser.value);
  if (response.data.code === 0) {
    await loginUserStore.fetchLoginUser();
    loginUser.value = {
      ...loginUserStore.loginUser,
    };
    message.success("修改成功");
    updateVisible.value = false;
  } else {
    message.error("修改失败，" + response.data.message);
  }
  updateLoading.value = false;
};

/**
 * 手机号修改
 */
const phoneForm = ref<API.UserPhoneRequest>({});
const phoneVisible = ref(false);

const updatePhone = () => {
  phoneVisible.value = true;
  getCode();
};

const updateLoading = ref(false);
/**
 * 修改手机号
 */
const submitUserPhone = async () => {
  updateLoading.value = true;
  // 验证参数
  if (
    phoneForm.value.userPhone == undefined ||
    phoneForm.value.userPhone == ""
  ) {
    message.warning("请输入手机号");
    return;
  }
  if (
    phoneForm.value.phoneCode == undefined ||
    phoneForm.value.phoneCode == ""
  ) {
    message.warning("请输入验证码");
    return;
  }
  // 发送请求
  const response = await editMyUserPhoneUsingPost(phoneForm.value);
  if (response.data.code === 0) {
    await loginUserStore.fetchLoginUser();
    loginUser.value = {
      ...loginUserStore.loginUser,
    };
    message.success("修改成功");
    phoneVisible.value = false;
  } else {
    message.error("修改失败，" + response.data.message);
  }
  updateLoading.value = false;
};

/**
 * 获取手机验证码
 */
const loading = ref(false);
const getPhoneCode = async () => {
  if (loading.value == true) return;
  if (phoneForm.value.userPhone == undefined) {
    message.warning("请输入手机号");
    return;
  }
  if (imgCode.value == "") {
    message.error("请输入图形验证码");
    return;
  }
  const phone = ref<API.codeUsingGETParams>({
    userPhone: phoneForm.value.userPhone as string,
    imgCodeKey: codeMap.value.key,
    imgCode: imgCode.value,
  });
  const response = await codeUsingGet(phone.value);
  if (response.data.code === 0) {
    message.success("验证码已发送");
    loading.value = true;
    // 设置倒计时
    countdown(60);
  } else {
    message.error(response.data.message as string);
  }
};
/**
 * 图形验证码
 */
const imgCode = ref("");
const codeMap = ref<any>({
  key: "",
  image: "",
});
const getCode = async () => {
  const res = await getCodeUsingGet({
    key: codeMap.value.key,
  });
  if (res.data.code === 0) {
    codeMap.value = res.data.data;
  } else {
    message.error(res.data.message as string);
  }
};

/**
 * 倒计时
 * @param t
 */
function countdown(t: number): void {
  loading.value = true;
  const timer = t > 0 ? t : 0;
  const button = document.getElementById("getCodeButton") as any;
  button.innerText = `${timer}秒后重新获取`;
  if (timer > 0) {
    setTimeout(() => countdown(timer - 1), 1000);
  } else {
    button.innerText = `获取验证码`;
    loading.value = false;
    return;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: updateUser.value,
      "label-align": "left",
      style: {"width":"50%"},
      "auto-label-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "用户名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: updateUser.value.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateUser.value.userName) = $event)),
              placeholder: "请输入用户名称..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "用户头像" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: "large" }, {
              default: _withCtx(() => [
                (updateUser.value.userAvatar)
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      src: updateUser.value.userAvatar,
                      width: "80px"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createVNode(PictureUpload, {
                  biz: "user_avatar",
                  modelValue: updateUser.value.userAvatar,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateUser.value.userAvatar) = $event)),
                  onChange: (url) => (updateUser.value.userAvatar = url)
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "手机号" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: "large" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(loginUser.value.userPhone == null ? "未绑定" : loginUser.value.userPhone), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_link, { onClick: updatePhone }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(loginUser.value.userPhone == null ? "添加手机号" : "修改手机号"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "用户简介" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: updateUser.value.userProfile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateUser.value.userProfile) = $event)),
              placeholder: "请输入用户简介..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_popconfirm, {
                  content: "你确定要修改吗?",
                  onOk: submitUser,
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      loading: updateLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("修改信息")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_modal, {
      visible: phoneVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((phoneVisible).value = $event)),
      draggable: "",
      footer: false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(loginUser.value.userPhone == null ? "添加手机号" : "修改手机号"), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-align": "left",
          "auto-label-width": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "手机号",
              label: "手机号",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: phoneForm.value.userPhone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((phoneForm.value.userPhone) = $event)),
                  placeholder: "请输入手机号..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "验证码",
              label: "验证码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: "large" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: phoneForm.value.phoneCode,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phoneForm.value.phoneCode) = $event)),
                      placeholder: "请输入手机验证码..."
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_a_button, {
                      id: "getCodeButton",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (getPhoneCode())),
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 获取验证码 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "code",
              label: "图形验证码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: imgCode.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((imgCode).value = $event)),
                      placeholder: "请输入图形验证码..."
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("img", {
                      style: {"width":"120px","height":"35px"},
                      src: codeMap.value.image
                    }, null, 8, _hoisted_1),
                    _createVNode(_component_a_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (getCode()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("刷新")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  content: "你确定要修改吗?",
                  onOk: submitUserPhone,
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(loginUser.value.userPhone == null ? "添加" : "修改"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})